import workspaceQuery from '../../queries/product/LuckinsItemImportFailureWorkspaceQuery.graphql';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const LuckinsItemImportFailure: EntityType = {
  type: 'LuckinsItemImportFailure',
  title: 'Luckins Item Import Failures',
  workspaceUrl: '/Products/Luckins/LuckinsItemImportFailure/Workspace/',
  workspace: workspaceQuery,
  screenReference: 'LUCKINS_ITEM_IMPORT_FAILURE',
  operations: ALLOW_VIEW,
};

export default LuckinsItemImportFailure;
